const NavigationParser = {};
NavigationParser.getNavigationParser = (res) => {
  if (!res) {
    return {};
  }


  if (res) {
   const data = res?.result
    return data;
  }
};  



export { NavigationParser };